/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

/**
 * Custom React hook to get the the Klarna client id based on the current locale
 * @returns {{getKlarnaClientId: function}}
 */
const useKlarna = () => {
    const {customParams} = getConfig()
    let hasKlarna = false

    const klarnaClientId = customParams?.klarna || ''

    if (klarnaClientId) hasKlarna = true

    return {klarnaClientId, hasKlarna}
}

export default useKlarna
